<template>
  <el-dialog
    id='problemOrderTracking'
    :title="data.title"
    @close="closeDialog"
    :visible.sync="isShow"
    width="1000px"
    class="dialog_class"
    :close-on-click-modal="false"
  >
    <div class="timeline" v-loading = 'loading'>
      <div class="orderInfo" style="margin-bottom:10px">
        <span style="margin-right:20px" v-if="isYto">物流公司：圆通速递</span>
        <span style="margin-right:20px" v-else-if="companyName">物流公司：{{companyName}}</span>
        <span >运单号：{{data.code}}</span>
        <span class="favoritesFolder" :class="{'active': isIncluded}" @click="changeCollectBtn(data.code)">
          <svg-icon v-if="isIncluded" icon-class="icon_shoucang_no" class="icon-svg-print-style"></svg-icon>
          <svg-icon v-else icon-class="icon_shoucang_yes" class="icon-svg-print-style"></svg-icon>
          <span class="text">{{isIncluded ? '取消收藏' : '收藏单号'}}</span>
          <span class="cancelCollect" v-if="curActiveCollectIndex">
            <span class="confirm_tip">确认取消收藏吗？</span>
            <span class="confirm_btn">
              <span class="flag_btn" @click.prevent.stop="curActiveCollectIndex=false">取消</span>
              <span class="flag_btn confirm" @click.prevent.stop="cancelCollectWaybill(data.code)">确认</span>
            </span>
          </span>
        </span>
      </div>
      <div class="orderInfo" style="margin-bottom:0">
        <span style="margin-right:20px" v-if="data.kcode || data.kname">
          客户信息：
          <span v-if="data.kcode">{{data.kcode}}</span>
          <span v-if="data.kcode && data.kname"> - </span>
          <span v-if="data.kname">{{data.kname}}</span>
        </span>
        <span style="margin-right:20px" v-if="data.sellerName">商家信息：{{data.sellerName}}</span>
      </div>
      <div class="flex" style="width:100%;justify-content: center;">
        <div style="width:50%">
          <div class="yto-title">收件信息</div>
          <div class="info-box">
            <p class="flex">
              <span class="info-title">姓名：</span>
              <span>{{info.receiverName}}</span>
            </p>
            <div class="flex">
              <p class="flex phone-div">
                <span class="info-title">手机号码：</span>
                <span>{{info.receiverMobile}}</span>
              </p>
              <p class="flex phone-div">
                <span class="info-title">电话号码：</span>
                <span>{{info.receiverPhone}}</span>
              </p>
            </div>
            <p class="flex">
              <span class="info-title">收货地址：</span>
              <span>{{info.receiverProvName}}{{info.receiverCityName}}{{info.receiverTownName}}{{info.receiverAddress}}</span>
            </p>
          </div>
        </div>
        <div style="width:50%">
          <div class="yto-title">寄件信息</div>
          <div class="info-box">
            <p class="flex">
              <span class="info-title">姓名：</span>
              <span>{{info.senderName}}</span>
            </p>
            <div class="flex">
              <p class="flex phone-div">
                <span class="info-title">手机号码：</span>
                <span>{{info.senderMobile}}</span>
              </p>
              <p class="flex phone-div">
                <span class="info-title">电话号码：</span>
                <span>{{info.senderPhone}}</span>
              </p>
            </div>
            <p class="flex">
              <span class="info-title">收货地址：</span>
              <span>{{info.senderProvName}}{{info.senderCityName}}{{info.senderTownName}}{{info.senderAddress}}</span>
            </p>
          </div>
        </div>
      </div>
      <div style="width:100%">
        <div class="yto-title">售后信息</div>
        <div style="padding:0 40px;">
          <el-table
            :data="tableData"
            border
            style="width: 100%;">
            <el-table-column
              prop="afterSaleType"
              align="center"
              label="工单类型"
              width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.afterSaleType == 1">发起的</span>
                <span v-if="scope.row.afterSaleType == 2">收到的</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="problemTypeName"
              align="center"
              label="问题类型">
            </el-table-column>
            <el-table-column
              prop="launchTime"
              align="center"
              label="发起/生成时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="dealTypeName"
              align="center"
              label="处理状态"
              width="100">
            </el-table-column>
            <el-table-column
              prop="dealDesc"
              align="center"
              label="处理结果">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="yto-title">物流信息</div>
      <div class="alert-warning" style="text-align:left;padding: 0px 0px 10px 0px;" v-if="orderData.length > 0 && orderData[0].documents">
        <el-alert type="warning" show-icon :closable="false" >
          <span>{{orderData[0].documents}}</span>
        </el-alert>
      </div>
      <ul v-if="orderData.length > 0">
        <li class="timeline-item-first" v-for="(item, i) in orderData" :key="i">
          <template v-if="isYto">
            <div class="timeline-item-time">
              <h3>{{getDateTime(item.waybillProcessInfo['upload_Time'])}}</h3>
              <p>{{getDateTime(item.waybillProcessInfo['upload_Time'], 1)}}</p>
            </div>
            <div class="timeline-item-color">
              <i class="circle-icon"></i>
            </div>
            <div class="timeline-item-tail"></div>
            <div class="timeline-item-content flex">
              <p>{{getProcessInfo(item.waybillProcessInfo['processInfo'])}}</p>
              <div class="view-icon" v-if="item.opOrgCode&&i==0" @click="(event)=>{
                    viewOrg(event,item)
              }"></div>
            </div>
          </template>
          <template v-else>
            <div class="timeline-item-time">
              <h3>{{getDateTime(item['time'])}}</h3>
              <p>{{getDateTime(item['time'], 1)}}</p>
            </div>
            <div class="timeline-item-color">
              <i class="circle-icon"></i>
            </div>
            <div class="timeline-item-tail"></div>
            <div class="timeline-item-content flex">
              <p>{{getProcessInfo(item['context'])}}</p>
            </div>
          </template>
        </li>
      </ul>
      <el-alert title="暂无走件流程" type="info" :closable="false" show-icon v-else></el-alert>
    </div>
    <branch-org :dialogOption="dialogOption" :opOrgCode="opOrgCode" v-show="showBranchOrgDialog" @closeDialog="showBranchOrgDialog = false"></branch-org>
  </el-dialog>
</template>

<script>
import netAPI from '@/api';
import branchOrg from '@/components/branchOrg/index';
import { mailCancelCollectApi, mailCollectApi, queryMailCollectListApi } from '../../../api/queryWaybill';
// import thirdNavVue from '../../layout/thirdNav.vue';
export default {
  props: {
    data: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      tableData:[],
      loading: false,
      isShow: this.value,
      orderData: [],
      companyName: '',
      isYto: false,
      dialogOption: {
        x: 0,
        y: 0
      },
      showBranchOrgDialog: false,
      opOrgCode: '',
      info: {},
      isIncluded: false,
      curActiveCollectIndex: false
    };
  },
  components: {
    branchOrg
  },
  mounted() {
    if (this.data && this.data.code) {
      this.companyName = '圆通速递';
    };
    this.queryAfterSale();
    this.searchWaybillAssignFetch();
    this.showCode();
    this.queryIsYtoMail();
    this.queryMailIsIncluded(this.data.code);
    this.bus.$on('openIMDialog', () => {
      this.closeDialog();
    });
  },
  methods: {
    searchWaybillAssignFetch() {
      // let params = {
      //   waybillNo: this.data.code
      // };
      // this.loading = true;
      netAPI
        .searchWaybillAssignFetch(this.data.code)
        .then((res) => {
          if (res.success && res.data) {
            this.info = res.data.data || {};
          } else {
            this.info = {};
          }
        })
        .catch((err) => {
          this.loading = false;
          this.info = {};
          this.$message.error(err.error);
        });
    },
    queryIsYtoMail() {
      let params = {
        waybillNo: this.data.code ? this.data.code : ''
      };
      netAPI.queryIsYtoMail(params).then(res => {
        if (res.data) {
          this.isYto = true;
        } else {
          this.isYto = false;
        }
      }).catch(() => {
        this.isYto = false;
      });
    },
    showCode() {
      let params = {
        waybillNo: this.data.code
      };
      this.loading = true;
      netAPI
        .getOrderTrackLost(params)
        .then((res) => {
          this.loading = false;
          if (res.success === true) {
            if (res.data) {
              this.orderData =
                (res.data && res.data.length && res.data[0].trackSimpleInfoDtos) || (res.data && res.data.length && res.data) || [];
              this.companyName =
                (res.data && res.data.length && res.data[0].companyName) || '';
            } else {
              this.orderData = [];
              this.companyName = '';
            }
          } else {
            this.orderData = [];
            this.companyName = '';
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.error);
        });
      // console.log('this.data.code', this.data.code);
    },
    getDateTime(date, num = 0) {
      if (!date) return false;
      let dateArray = date.split(' ');
      let returnTxt = '';
      if (num) {
        returnTxt = dateArray[num].slice(0, 5);
      } else {
        returnTxt = dateArray[num].slice(5);
      }
      return returnTxt;
    },
    getProcessInfo(text) {
      let returnTxt = '';
      if (text) {
        returnTxt = text;
      }
      // console.log('111', returnTxt);
      return returnTxt;
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    },
    viewOrg(event, item) {
      this.dialogOption = {
        x: event.pageX - 126,
        y: event.pageY + 20
      };
      this.opOrgCode = item.opOrgCode;
      this.showBranchOrgDialog = true;
    },
    // 查询运单是否收藏
    queryMailIsIncluded(waybillNo) {
      let params = {
        logInId: this.userMess.loginId,
        waybillNo: waybillNo,
        limit: 10,
        pageNo: 1
      };
      queryMailCollectListApi(params).then(res => {
        if (res.rows && res.rows.length > 0) {
          this.$set(this, 'isIncluded', true);
        } else {
          this.$set(this, 'isIncluded', false);
        }
      }).catch(() => {
        this.$set(this, 'isIncluded', false);
      });
    },
    // 点击取消息收藏、或 添加收藏
    changeCollectBtn(waybillNo) {
      if (this.isIncluded) {
        // 点击取消收藏,弹出二次确认框
        this.curActiveCollectIndex = true;
      } else {
        // 点击收藏，调用收藏单号接口
        this.mailCollect(waybillNo);
      }
    },
    // 收藏单号
    mailCollect(waybillNo) {
      let params = {
        logInId: this.userMess.loginId,
        waybillNo: waybillNo
      };
      let loadingMask = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      mailCollectApi(params).then(res => {
        loadingMask.close();
        if (res.success) {
          this.$message.success('运单号收藏成功');
          this.$set(this, 'isIncluded', true);
        } else {
          this.$message.error('运单号收藏失败');
        }
      }).catch(() => {
        loadingMask.close();
        this.$message.error('运单号收藏失败');
      });
    },
    // 取消收藏
    cancelCollectWaybill(waybillNo) {
      // 调用取消收藏接口...
      this.curActiveCollectIndex = false; // 关闭弹层
      this.mailCancelCollect(waybillNo);
    },
    // 取消收藏单号
    mailCancelCollect(waybillNo) {
      let params = {
        logInId: this.userMess.loginId,
        waybillNo: waybillNo
      };
      let loadingMask = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      mailCancelCollectApi(params).then(res => {
        loadingMask.close();
        if (res.success) {
          this.$message.success('运单号取消收藏成功');
          this.$set(this, 'isIncluded', false);
        } else {
          this.$message.error('运单号取消收藏失败');
        }
      }).catch(() => {
        loadingMask.close();
        this.$message.error('运单号取消收藏失败');
      });
    },
    queryAfterSale(){
      let params = {
        logInId: this.userMess.loginId,
        groupId: this.userMess.groupId,
        waybillNo: this.data.code ? this.data.code : ''
      };
      this.loading = true;
      netAPI.queryAfterSale(params).then(res => {
        this.loading = false;
        if (res.status == 0) {
          this.tableData = res.data || [];
        } else {
          this.tableData = [];
        }
      }).catch(() => {
        this.loading = false;
        this.tableData = [];
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import '../../../styles/variables';
#problemOrderTracking{
  .dialog {
    .el-dialog__body {
      min-height: 60vh !important;
    }
  }
   .favoritesFolder {
    position: relative;
    display: inline-block;
    width: 84px;
    height: 29px;
    line-height: 25px;
    margin-left: 20px;
    text-align: center;
    border-radius: 3px;
    background: #FFFBF2;
    border: 1px solid $yellow;
    cursor: pointer;
    .icon-svg-print-style {
      width: 14px;
      height: 14px;
    }
    .text {
      font-size: 12px;
      color: $yellow;
    }
  }
  .favoritesFolder.active {
    background-color: $yellow;
    .text {
      color: $white;
    }
    .cancelCollect {
      position: absolute;
      z-index: 99;
      width: 276px;
      height: 85px;
      left: 0;
      top: 36px;
      padding: 10px;
      background-color: $white;
      border-radius: 3px;
      box-shadow: 0px 1px 11px 0px rgba(109, 140, 209, 0.22);
      .confirm_tip {
        display: block;
        font-size: 14px;
        color: $color-style;
        padding: 0px 10px 20px;
        text-align: left;
      }
      .confirm_btn {
        display: block;
        text-align: right;
        .flag_btn {
          display: inline-block;
          width: 60px;
          height: 26px;
          border: 1px solid #DCDFE6;
          color: $color-style;
          text-align: center;
          line-height: 26px;
          border-radius: 3px;
          font-size: 12px;
        }
        .flag_btn.confirm {
          margin-left: 12px;
          color: $white;
          border-color: $blue-style;
          background-color: $blue-style;
        }
      }
    }
  }
}
@import '../../../styles/variables';
#problemOrderTracking{
.timeline {
  .orderInfo {
    margin-bottom: 20px;
    padding-left: 40px;
  }
  ul {
    height: 300px;
    overflow: auto;
  }
  li {
    list-style: none;
    position: relative;
    overflow: hidden;
    padding-bottom: 20px;
    .timeline-item-content {
      width: 750px;
      p {
        text-align: left;
      }
      .view-icon{
        width: 35px;
        height: 24px;
        background: url('../../../assets/images/im/icon_duihua@2x.png');
        background-repeat: no-repeat;
        margin-left: 4px;
        cursor: pointer;
        background-size: contain;
      }
    }
    &:first-child {
      .timeline-item-tail {
        top: 2px;
      }
      .timeline-item-color {
        border-color: $blue-style;
      }
      .circle-icon {
        background-color: $blue-style;
      }
      .timeline-item-content {
        width: 750px;
        p {
          text-align: left;
          color: $blue-style !important;
        }
      }
      .timeline-item-time {
        h3 {
          color: $blue-style !important;
        }
        p {
          color: $blue-style !important;
        }
      }
    }
  }
}
.timeline-item-color {
  border: 2px solid #dcdfe6;
  left: 60px;
  top: 2px;
  position: absolute;
  content: '';
  z-index: 99;
  border-radius: 99px;
}
.timeline-item-tail {
  position: absolute;
  content: '';
  height: 100%;
  width: 2px;
  left: 68px;
  top: 0;
  background-color: #dcdfe6;
}
.circle-icon {
  width: 10px;
  height: 10px;
  background-color: #dcdfe6;
  display: block;
  border-radius: 99px;
  border: 2px solid #fff;
}
.timeline-item-time {
  width: 50px;
  float: left;
  h3 {
    margin: 0;
    padding: 0;
    text-align: right;
    font-weight: lighter;
    color: #a2a5ac;
  }
  p {
    margin: 0;
    text-align: right;
    color: #a2a5ac;
  }
}
.timeline-item-content {
  float: left;
  margin-left: 40px;
  h3 {
    margin: 0;
    padding: 0;
    font-weight: 500;
    color: #a2a5ac;
  }
  p {
    margin-top: 5px;
    text-align: right;
    color: #a2a5ac;
  }
}
.flex{
  display: flex;
}
.info-box{
  padding:0 40px;
  p{
    margin-top: 0;
  }
  .info-title{
    width: 80px;
    text-align: right;
    display: inline-block;
    flex-shrink: 0;
  }
}
.phone-div{
   width:50%;
   flex-shrink: 0;
}
}
</style>
